export default["__VITE_ASSET__G$2q4X87__","__VITE_ASSET___HUOTQKp__"];